import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10","key":"svg-0"}],["path",{"d":"M6 8h.01","key":"svg-1"}],["path",{"d":"M9 8h.01","key":"svg-2"}]]

const IconAppWindow = createReactComponent('outline', 'app-window', 'AppWindow', __iconNode);

export default IconAppWindow;